import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";

const EmployeeEmploymentForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    employee_id: "",
    branch: "",
    designation: "",
    employee_type: "",
    date_of_joining: "",
    is_active: true,
  });

  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...formData,
        employee_id: Number(formData.employee_id),
      };

      const response = await axios.post(
        "employment/",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Employment details saved successfully!");
      console.log(response.data);
      navigate("/dashboard/employees/list");
    } catch (error) {
      console.error(error.response?.data || error);
      alert(
        "Error saving employment details: " +
          JSON.stringify(error.response?.data)
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">Employment Details</h3>
          <button className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
            Back to Dashboard
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-4">
              <label>Employee ID</label>
              <input
                type="number"
                className="form-control"
                name="employee_id"
                value={formData.employee_id}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4">
              <label>Branch</label>
              <input
                type="text"
                className="form-control"
                name="branch"
                value={formData.branch}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4">
              <label>Designation</label>
              <input
                type="text"
                className="form-control"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4 mt-3">
              <label>Employee Type</label>
              <input
                type="text"
                className="form-control"
                name="employee_type"
                value={formData.employee_type}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4 mt-3">
              <label>Date of Joining</label>
              <input
                type="date"
                className="form-control"
                name="date_of_joining"
                value={formData.date_of_joining}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4 mt-4">
              <div className="form-check mt-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleChange}
                  id="isActive"
                />
                <label className="form-check-label" htmlFor="isActive">
                  Active Employee
                </label>
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary mt-3"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Employment Details"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmployeeEmploymentForm;
